/**
 * Thumb preset pro og:image. Odpovídá presetu `facebook-share` ze starého webu
 * (`fit: focalpoint` respektuje ohnisko nastavené v adminu), rozměr 1200×630 je
 * doporučení Facebooku. `fm:jpeg` místo výchozího webp kvůli scraperům, které
 * webp neberou.
 *
 * Přidej do `thumb` v dotazu entity a výsledek čti z `image.paths.thumbs.og`.
 *
 * Žije mimo `useOgImage.ts` schválně: ten volá `useDesignSettings()`, které si
 * tenhle preset naopak vyžaduje do svého dotazu — kdyby byl preset tam, vznikl
 * by mezi moduly cyklický import.
 *
 * Pozor na tvar parametrů (ověřeno proti API): rozměr se zadává jako `w`/`h`,
 * nikoli `width`/`height` (ty se tiše ignorují), a pojmenovaný `style` existuje
 * jen ve variantách `s|m|l|xl` — cokoli jiného spadne na 100px náhled.
 */
export const OG_IMAGE_THUMB = { og: { w: 1200, h: 630, fit: 'focalpoint', fm: 'jpeg', q: 80 } }
